import store from '@/store'

/**
 * v-permission 按钮级权限指令
 * 用法：<el-button v-permission="'access.permission.create'">添加</el-button>
 *      <el-button v-permission="['access.permission.create', 'access.permission.update']">添加/编辑</el-button>
 * 逻辑：超管（isSuperAdmin）放行；否则查 permissionCodes 数组是否包含任一传入 code
 * 不通过则直接从 DOM 移除元素
 */
function check(value) {
  // 超管直接放行
  if (store.state.user.isSuperAdmin) return true

  const codes = store.state.user.permissionCodes || []
  // 支持传入单个字符串或数组
  const needCodes = Array.isArray(value) ? value : [value]
  return needCodes.some(code => codes.includes(code))
}

export default {
  inserted(el, binding) {
    if (!check(binding.value)) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
